module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item border-left-0"
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/home.png"),
      "height": "40"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v(_vm._s(_vm.$t('assessment_test')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-3 mb-3 pt-5 pb-5 bg-white",
    staticStyle: {
      "min-height": "60vh"
    }
  }, [_c('div', {
    staticClass: "row box"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._v("\n        " + _vm._s(_vm.summary.userName) + " 的能力檢測紀錄"), _c('br'), _vm._v("\n        目前檢測次數：" + _vm._s(_vm.summary.examCount) + " 次（推定等級：" + _vm._s(_vm.summary.userLevel || 'N/A') + "）\n\n        "), _c('score-chart', {
    ref: "chart",
    staticClass: "mt-1",
    attrs: {
      "chartdata": _vm.chartdata,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-border"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_vm._v("\n          " + _vm._s(_vm.summary.userName) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.summary.examCount > 0 ? '' : '您尚未進行能力檢測')), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block mt-5 mb-5 w-100 mx-auto",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.push('/quiz/start')
      }
    }
  }, [_vm._v("前往能力檢測")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "text-left pt-3"
  }, [_vm._v("\n            總分：" + _vm._s(_vm.summary.score || 0) + "分"), _c('br'), _c('br'), _vm._v("\n            聽力：" + _vm._s(_vm.summary.listeningScore || 0) + " 分"), _c('br'), _c('br'), _vm._v("\n            閱讀：" + _vm._s(_vm.summary.readingScore || 0) + " 分"), _c('br'), _c('br'), _vm._v("\n            測驗日期：" + _vm._s(_vm.summary.lastTime ? _vm.dateParsing(_vm.summary.lastTime) : '- / - / -') + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84c8f740!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Quiz.vue
// module id = 744
// module chunks = 1